import React from 'react';
import { ContentHero, Paper } from 'library';
import useSpecificPage from 'utils/useSpecificPage';

import Block from '../../blocks/Block';
import CMSContent from '../../common/CMSContent/CMSContent';
import WistiaVideoOverlay from '../../common/WistiaVideoOverlay/WistiaVideoOverlay';
import Layout from '../../layout';

import './HeroSingleColumn.scss';

const HeroSingleColumn = ({ data }) => {
  const { isHowItWorksPage } = useSpecificPage();
  const {
    page: {
      templateFields: {
        heroSingleColumnFields: {
          heading,
          copy,
          theme,
          image: { sourceUrl },
          heroCta: [hero],
        },
        blocks,
      },
    },
  } = data;

  return (
    <Layout className="HeroSingleColumn">
      <Paper className="HeroSingleColumnHeader" theme={theme}>
        <ContentHero title={heading} image={sourceUrl} buttonLabel={hero.text} buttonLink={hero.url}>
          <CMSContent content={copy} />
          {isHowItWorksPage() && (
            <WistiaVideoOverlay videoId="xxbvs27hmp" ctaText="VIDEO: WHAT IS HOMETAP? 1 MINUTE OVERVIEW" />
          )}
        </ContentHero>
      </Paper>

      {blocks?.map((block, index) => (
        <Block data={block} key={index} />
      ))}
    </Layout>
  );
};

export default HeroSingleColumn;
